import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TermsAcceptanceModal = ({ show, onAccept, onDecline, loading = false }) => {
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    if (accepted) {
      onAccept();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onDecline} 
      backdrop="static" 
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
          <i className="bi bi-file-text me-2"></i>
          Acceptation des conditions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="info" className="border-0">
          <i className="bi bi-info-circle me-2"></i>
          <strong>Bienvenue sur Assistance Video !</strong>
          <p className="mb-0 mt-2 small">
            Avant de commencer à utiliser notre service, nous vous invitons à prendre connaissance
            et à accepter nos conditions d'utilisation et de vente.
          </p>
        </Alert>

        <div className="my-4">
          <h6 className="fw-bold mb-3">Documents à consulter :</h6>
          <div className="list-group">
            <Link 
              to="/legal/cgu/" 
              target="_blank" 
              className="list-group-item list-group-item-action d-flex align-items-center"
            >
              <i className="bi bi-file-earmark-text text-primary me-3" style={{ fontSize: '1.5rem' }}></i>
              <div>
                <div className="fw-semibold">Conditions Générales d'Utilisation (CGU)</div>
                <small className="text-muted">Règles d'utilisation du service</small>
              </div>
              <i className="bi bi-box-arrow-up-right ms-auto text-muted"></i>
            </Link>
            
            <Link 
              to="/legal/cgv/" 
              target="_blank" 
              className="list-group-item list-group-item-action d-flex align-items-center"
            >
              <i className="bi bi-cart-check text-primary me-3" style={{ fontSize: '1.5rem' }}></i>
              <div>
                <div className="fw-semibold">Conditions Générales de Vente (CGV)</div>
                <small className="text-muted">Conditions d'achat des crédits</small>
              </div>
              <i className="bi bi-box-arrow-up-right ms-auto text-muted"></i>
            </Link>
            
            <Link 
              to="/legal/privacy/" 
              target="_blank" 
              className="list-group-item list-group-item-action d-flex align-items-center"
            >
              <i className="bi bi-shield-check text-primary me-3" style={{ fontSize: '1.5rem' }}></i>
              <div>
                <div className="fw-semibold">Politique de Confidentialité</div>
                <small className="text-muted">Protection de vos données personnelles</small>
              </div>
              <i className="bi bi-box-arrow-up-right ms-auto text-muted"></i>
            </Link>
          </div>
        </div>

        <div className="bg-light p-3 rounded">
          <Form.Check
            type="checkbox"
            id="accept-terms"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            label={
              <span>
                J'ai lu et j'accepte les{' '}
                <Link to="/legal/cgu/" target="_blank" className="fw-semibold">
                  Conditions Générales d'Utilisation
                </Link>
                {' '}et les{' '}
                <Link to="/legal/cgv/" target="_blank" className="fw-semibold">
                  Conditions Générales de Vente
                </Link>
                {' '}de Assistance Video.
              </span>
            }
            disabled={loading}
          />
        </div>

        <p className="text-muted small mt-3 mb-0">
          <i className="bi bi-info-circle me-1"></i>
          En acceptant ces conditions, vous confirmez avoir pris connaissance de notre politique
          de confidentialité et de la manière dont nous traitons vos données personnelles conformément
          au RGPD.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="outline-secondary" 
          onClick={onDecline}
          disabled={loading}
        >
          <i className="bi bi-x-circle me-2"></i>
          Refuser
        </Button>
        <Button 
          variant="primary" 
          onClick={handleAccept}
          disabled={!accepted || loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Validation en cours...
            </>
          ) : (
            <>
              <i className="bi bi-check-circle me-2"></i>
              Accepter et continuer
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAcceptanceModal;

